import styled, {css} from 'styled-components';

const StyledAddPaymentForm = styled.div`
  display: flex;
  flex-direction: column;

  .vendor-payments-list {
    margin-bottom: 16px;

    .vendor-payments-full-list {
      max-height: 160px;
      overflow: auto;
    }
  }

  .ant-form {
    ${props => props.size === 'half' && css`
      column-gap: 16px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      .ant-form-item {
        display: inline-flex;
        width: calc((100% - 16px) / 2);
        transition: .2s ease;

        &.w-100 {
          width: 100%;
        }

        &:first-of-type {
          width: 100%;
        }

        & > .ant-form-item-row {
          width: 100%;
        }
      }

      .ReactCollapse--collapse {
        width: calc((100% - 16px) / 2);
      }
    `}

    &.disabled-form {
      .vendor-selector {
        background: rgba(0, 0, 0, 0.04);
        color: rgba(0, 0, 0, 0.25);
        cursor: not-allowed;

        .ant-dropdown-trigger {
          cursor: not-allowed;
          &:hover {
            border-color: ${props => props.theme.colors.neutral_4};
          }
        }
      }
    }
  }

  .ant-form-item-has-error {
    .ant-dropdown-trigger {
      border-color: ${props => props.theme.colors.functional_danger};
    }
  }
`;

export {
  StyledAddPaymentForm,
};
